import * as React from 'react';

function SvgResidentTypeStudentOnly(props) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 96" {...props}>
      <path
        d="M19 23a2 2 0 012-2h35a2 2 0 012 2v7a2 2 0 01-2 2H21a2 2 0 01-2-2v-7zM51 2a2 2 0 012-2h40a2 2 0 012 2v7a2 2 0 01-2 2H53a2 2 0 01-2-2V2zM22 68h36v7H22z"
        fill="#F5F5F5"
      />
      <path
        d="M32 62a2 2 0 012-2h12a2 2 0 012 2v13a2 2 0 01-2 2H34a2 2 0 01-2-2V62zm-13-7.5A9.5 9.5 0 019.5 64 9.5 9.5 0 010 54.5 9.5 9.5 0 019.5 45a9.5 9.5 0 019.5 9.5z"
        fill="#F5F5F5"
      />
      <path
        d="M30 39.5a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zM44.5 38a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zm0 11a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zm-13 0a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zM63 23.5a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zm13 0a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zm0 11a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zm-13 0a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5z"
        fill="#BFBFBF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51 9a2 2 0 002 2h2v10H21a2 2 0 00-2 2v7a2 2 0 002 2h1v42H10.915c.055-.156.085-.325.085-.5v-9.618c4.534-.719 8-4.646 8-9.382a9.5 9.5 0 00-19 0c0 4.736 3.466 8.663 8 9.382V73.5c0 .175.03.344.085.5H2.5a1.5 1.5 0 000 3h61a1.5 1.5 0 000-3H58v-1h33V11h2a2 2 0 002-2V2a2 2 0 00-2-2H53a2 2 0 00-2 2v7zm3-6v5h38V3H54zm-9 71H35V63h10v11zm3-12v12h7V32H25v42h7V62a2 2 0 012-2h12a2 2 0 012 2zm10 8h30V11H58v59zm-3-46H22v5h33v-5zM16 54.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
        fill="#BFBFBF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43 66.5C43 82.792 56.208 96 72.5 96S102 82.792 102 66.5 88.792 37 72.5 37 43 50.208 43 66.5z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50 67.324c0 12.329 9.926 22.323 22.17 22.323 12.245 0 22.171-9.994 22.171-22.323 0-12.33-9.926-22.324-22.17-22.324C59.926 45 50 54.995 50 67.324z"
        fill="#F5F5F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.262 77.491l2.126.972c6.323-14.196.81-30.902-12.694-38.463l-1.126 2.035c12.452 6.966 17.533 22.373 11.694 35.456zM46 79.724C51.073 89.682 61.238 95.96 72.353 96a29.535 29.535 0 0012.103-2.64l-.949-2.146c-13.25 5.952-28.809.435-35.431-12.563L46 79.724zm26.245-26.308c.291-.091.603-.091.895 0l12.618 3.943a1.5 1.5 0 010 2.863l-5.706 1.783a8.335 8.335 0 01.907 3.796 8.331 8.331 0 01-3.657 6.911c2.985 1.301 5.39 3.822 6.77 6.94a1.5 1.5 0 01-2.744 1.214c-1.643-3.713-4.952-6.117-8.636-6.117-3.683 0-6.993 2.404-8.635 6.117a1.501 1.501 0 01-2.744-1.214c1.38-3.118 3.785-5.639 6.77-6.94a8.332 8.332 0 01-3.658-6.911c0-1.368.328-2.658.907-3.796l-2.258-.705v6.944a1.5 1.5 0 01-3 0v-7.515c0-.122.015-.24.042-.354l-.489-.153a1.498 1.498 0 010-2.863l12.618-3.943zm.895 10.749l3.984-1.244c.528.828.835 1.815.835 2.88 0 2.96-2.377 5.324-5.267 5.324-2.889 0-5.267-2.364-5.267-5.324 0-1.065.308-2.052.836-2.88l3.984 1.244c.291.092.603.092.895 0zm-8.037-5.374l7.589 2.371 7.589-2.371-7.589-2.372-7.589 2.372z"
        fill="#BFBFBF"
      />
    </svg>
  );
}

export default SvgResidentTypeStudentOnly;
